export default __webpack_public_path__ + "static/media/delete-icon.485095d8.svg";